import { useState } from 'react';
import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import { CoursesViewAllCourses } from 'components/courses';

import type { HomeModuleProps } from './Home';

const HomeCoursesSelected = ({
  defaultTitle,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module || !module.courses?.length) return null;

  const queryParams = `&id=${module.courses.join(filterValuesSeparator)}`;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <CoursesViewAllCourses
        defaultSort="queryIds"
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        queryParams={queryParams}
        title={title}
        titleShowCount={false}
      />
    </div>
  );
};

export default HomeCoursesSelected;
